const BiogCard = ({ name, role, bio, image, links = {} }) => {
  return (
    <div className="col">
      <div
        className="card bg-body-tertiary h-100 text-center shadow p-3 transition"
        style={{
          borderRadius: '1rem',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-5px)';
          e.currentTarget.style.boxShadow = '0 0.5rem 1rem rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 0.25rem 0.5rem rgba(0,0,0,0.05)';
        }}
      >
        <div className="d-flex justify-content-center mt-2">
          <img
            src={image}
            alt={name}
            className="rounded-circle shadow"
            style={{
              width: '120px',
              height: '120px',
              objectFit: 'cover',
              border: '4px solid white',
              marginTop: '0.5rem',
            }}
          />
        </div>

        <div className="card-body">
          <h3 className="tt-heading text-white">{name}</h3>
          {role && <p className="mb-2 text-warning fw-bold">{role}</p>}
          {bio && <p className="card-text">{bio}</p>}
        </div>

        {(links.github || links.linkedin || links.website) && (
          <div className="pb-3 d-flex justify-content-center gap-3">
            {links.github && (
              <a
                href={links.github}
                target="_blank"
                rel="noopener noreferrer"
                title="GitHub"
              >
                <i className="bi bi-github fs-4"></i>
              </a>
            )}
            {links.devto && (
              <a
                href={links.devto}
                target="_blank"
                rel="noopener noreferrer"
                title="dev.to"
              >
                <i className="bi bi-code fs-4"></i>
              </a>
            )}
            {links.linkedin && (
              <a
                href={links.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
              >
                <i className="bi bi-linkedin fs-4"></i>
              </a>
            )}
            {links.website && (
              <a
                href={links.website}
                target="_blank"
                rel="noopener noreferrer"
                title="Website"
              >
                <i className="bi bi-globe fs-4"></i>
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BiogCard;
